import renderApplication from "initializers/renderApplication";
import "@ableco/baseline/style.css";
import "initializers/standardizeBrowser";
import "styles/tailwind.css";

document.addEventListener("DOMContentLoaded", () => {
  renderApplication();
});
